<template>
  <!-- Footer-->
  <footer class="bg-dark">
    <div class="pt-4 bg-darker">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-6 text-center mb-4">
            <div class="text-nowrap mb-4">
              <a class="d-inline-block align-middle mt-n1 mr-3" href="#">
                <img class="d-block" width="300" src="img/myDesigns/pictures/footer-light.svg" alt="wirkaufendeine-kueche.de"/>
              </a>
            </div>
            <div class="widget widget-links widget-light">
              <ul class="widget-list d-flex flex-wrap justify-content-center">
                <li class="widget-list-item mr-4"><a class="widget-list-link" @click="scrollToEval" style="cursor: pointer">Bewerten</a></li>
                <li class="widget-list-item mr-4"><a class="widget-list-link" @click="routeToMarket" style="cursor: pointer">Gebrauchtküchenmarkt</a></li>
                <li class="widget-list-item mr-4"><button type="button" class="btn btn-link widget-list-link p-0" style="cursor: pointer"
                  data-container="body" data-toggle="popover" data-placement="top" title="Persönliche Hilfe" data-content="mail@wirkaufendeine-kueche.de" 
                >
                Support
                </button></li>
                <li class="widget-list-item mr-4"><a class="widget-list-link" @click="routeToPrivacy" style="cursor: pointer">Datenschutz</a></li>
                <li class="widget-list-item mr-4"><a class="widget-list-link" @click="routeToImpressum" style="cursor: pointer">Impressum</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="pb-4 font-size-xs text-light opacity-50 text-center">© wirkaufendeine-kueche.de 2020</div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'myFooter',
  components: {
  },
  data: () => ({
    routes: {
      market: "marktplatz",
      privacy: "datenschutz",
      impressum: "impressum"
    }
  }),
  computed: {
  },
  created: function () {
  },
  mounted: function () {
  },
  methods: {
    scrollToEval: function () {
      const id = "evaluationCard";
      let element = document.getElementById(id);
      if (element !== null) {
        element.scrollIntoView();
      }
    },
    routeTo: function (destination) {
      this.$router.push({path: destination});
    },
    routeToMarket: function () {
      this.routeTo(this.routes.market);
    },
    routeToPrivacy: function () {
      this.routeTo(this.routes.privacy);
    },
    routeToImpressum: function () {
      this.routeTo(this.routes.impressum);
    } 
  }
}
</script> 